"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/2/2022
 */

var DataFilter = require("./DataFilter");
module.exports = /*#__PURE__*/function (_DataFilter) {
  (0, _inherits2["default"])(SearchKeywordsFilter, _DataFilter);
  var _super = _createSuper(SearchKeywordsFilter);
  function SearchKeywordsFilter() {
    var _this;
    var searchQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var searchField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "searchKeywords";
    var shouldTrim = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var toLowerCase = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    (0, _classCallCheck2["default"])(this, SearchKeywordsFilter);
    _this = _super.call(this);
    _this.searchField = "";
    _this.searchQuery = "";
    _this.shouldTrim = true;
    _this.toLowerCase = true;
    _this.searchField = searchField;
    _this.searchQuery = searchQuery;
    _this.shouldTrim = shouldTrim;
    _this.toLowerCase = toLowerCase;
    _this.reset(searchQuery);
    return _this;
  }
  (0, _createClass2["default"])(SearchKeywordsFilter, [{
    key: "reset",
    value: function reset() {
      var searchQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(SearchKeywordsFilter.prototype), "reset", this).call(this);
      this.searchQuery = searchQuery;
      var queryTerms = [];
      if (Array.isArray(searchQuery)) {
        queryTerms = searchQuery;
      } else {
        queryTerms = ("" + this.searchQuery).split(" ");
      }
      this.addTextSearchFilterOption(this.searchField, queryTerms, this.shouldTrim ? undefined : 0, this.toLowerCase);
    }
  }]);
  return SearchKeywordsFilter;
}(DataFilter);